import environment from "Configs/environment";

export function getImageUrl(name: string) {
  return `${environment.standaloneAppUrl}/assets/images/${name}`;
}

export function isImageMimeType(mimeType: string) {
  return IMAGE_MIME_TYPES.includes(mimeType.toLowerCase());
}

export function isPdfMimeType(mimeType: string) {
  return mimeType.toLowerCase() === PDF_MIME_TYPE;
}

const IMAGE_MIME_TYPES = ["image/gif", "image/png", "image/jpeg", "image/jpg", "image/svg+xml"];
const PDF_MIME_TYPE = "application/pdf";
